import { render, staticRenderFns } from "./DefaultTriangle.vue?vue&type=template&id=6b9ea7e3&scoped=true&"
import script from "./DefaultTriangle.vue?vue&type=script&lang=js&"
export * from "./DefaultTriangle.vue?vue&type=script&lang=js&"
import style0 from "./DefaultTriangle.vue?vue&type=style&index=0&id=6b9ea7e3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9ea7e3",
  null
  
)

export default component.exports